import type { EventGuestEntry } from './types';

/**
 * Guest-list CSV for the event manager. Two independent timestamps ride along:
 * "Paid at" is guest-list membership (redeemedAt), "Checked in at" is the door
 * fact (checkedInAt). They are never conflated.
 */
export const GUEST_CSV_HEADER = [
  'Name',
  'Email',
  'Ticket code',
  'Status',
  'Origin',
  'Invited by',
  'Paid at',
  'Checked in at'
];

function csvEscape(value: string): string {
  return /[",\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}

export function guestCsvRow(
  guest: EventGuestEntry,
  originLabels: Record<string, string> = {}
): string[] {
  return [
    guest.person?.name ?? '',
    guest.person?.email ?? '',
    guest.code ?? '',
    guest.status,
    originLabels[guest.origin] ?? guest.origin,
    guest.invitedBy?.personName ?? '',
    guest.redeemedAt ?? '',
    guest.checkedInAt ?? ''
  ];
}

export function buildGuestCsv(
  guests: EventGuestEntry[],
  originLabels: Record<string, string> = {}
): string {
  const rows = guests.map(guest => guestCsvRow(guest, originLabels));
  return [GUEST_CSV_HEADER, ...rows].map(row => row.map(csvEscape).join(',')).join('\n');
}
